export { useResultsCarouselData } from './useResultsCarouselData';
